import dynamic from 'next/dynamic';
import { ReslinkEventDetailsProps } from './ReslinkEventDetails.types';

export const ReslinkEventDetails = dynamic<{ model: ReslinkEventDetailsProps }>(() =>
  import('./ReslinkEventDetails').then(mod => mod.ReslinkEventDetails)
);
